/* eslint-disable import/no-unresolved */
import * as getStatic from '@backpackjs/core-nextjs/get-static';
import { useCustomerAuth, useSettings } from '@backpackjs/storefront';

import templates from '../../templates/account';
import { AccountsAuthLoader } from '../../_components';

export const getStaticProps = getStatic.props.settings;

const RegisterTemplate = templates['register'];

const authOptions = {
  autoRedirect: true,
  defaultRoute: '/account/orders',
  id: 'withRegister',
};

export default function Register({ settings: initialSettings }) {
  const liveSettings = useSettings();
  const settings = liveSettings || initialSettings;

  // will redirect to account if signed in
  const { authenticated } = useCustomerAuth(authOptions);

  return authenticated === false ? (
    RegisterTemplate ? (
      <RegisterTemplate action="register" settings={settings} />
    ) : (
      'Register template not provided'
    )
  ) : (
    <AccountsAuthLoader /> // while you are auto redirect
  );
}
